var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.49993H7.67531C7.46461 1.26402 7.20645 1.07527 6.91775 0.946037C6.62905 0.816804 6.31631 0.75 6 0.75C5.68369 0.75 5.37095 0.816804 5.08225 0.946037C4.79355 1.07527 4.53539 1.26402 4.32469 1.49993H2.625C2.42609 1.49993 2.23532 1.57895 2.09467 1.7196C1.95402 1.86025 1.875 2.05102 1.875 2.24993V10.1249C1.875 10.3238 1.95402 10.5146 2.09467 10.6553C2.23532 10.7959 2.42609 10.8749 2.625 10.8749H9.375C9.57391 10.8749 9.76468 10.7959 9.90533 10.6553C10.046 10.5146 10.125 10.3238 10.125 10.1249V2.24993C10.125 2.05102 10.046 1.86025 9.90533 1.7196C9.76468 1.57895 9.57391 1.49993 9.375 1.49993ZM6 1.49993C6.39782 1.49993 6.77936 1.65797 7.06066 1.93927C7.34196 2.22058 7.5 2.60211 7.5 2.99993H4.5C4.5 2.60211 4.65804 2.22058 4.93934 1.93927C5.22064 1.65797 5.60218 1.49993 6 1.49993ZM7.5 7.49993H4.5C4.40054 7.49993 4.30516 7.46042 4.23484 7.3901C4.16451 7.31977 4.125 7.22439 4.125 7.12493C4.125 7.02548 4.16451 6.93009 4.23484 6.85977C4.30516 6.78944 4.40054 6.74993 4.5 6.74993H7.5C7.59946 6.74993 7.69484 6.78944 7.76517 6.85977C7.83549 6.93009 7.875 7.02548 7.875 7.12493C7.875 7.22439 7.83549 7.31977 7.76517 7.3901C7.69484 7.46042 7.59946 7.49993 7.5 7.49993ZM7.5 5.99993H4.5C4.40054 5.99993 4.30516 5.96042 4.23484 5.8901C4.16451 5.81977 4.125 5.72439 4.125 5.62493C4.125 5.52548 4.16451 5.43009 4.23484 5.35977C4.30516 5.28944 4.40054 5.24993 4.5 5.24993H7.5C7.59946 5.24993 7.69484 5.28944 7.76517 5.35977C7.83549 5.43009 7.875 5.52548 7.875 5.62493C7.875 5.72439 7.83549 5.81977 7.76517 5.8901C7.69484 5.96042 7.59946 5.99993 7.5 5.99993Z",
    fill: "url(#paint0_linear_3172_3403)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3172_3403",
    x1: 1.875,
    y1: 5.81247,
    x2: 10.125,
    y2: 5.81247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#850515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9001E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardText);
export default __webpack_public_path__ + "static/media/ClipboardText.a779911ceeb5f55cdf7a53a8e9c10a67.svg";
export { ForwardRef as ReactComponent };